namespace Nobox {
    export interface latestSentMessage {
        Id?: number;
        Contact?: string;
        Status?: number;
        Message?: string;
        ProcessBy?: string;
        Sent?: string;
        IsRead?: number;
        DateRead?: string;
    }
}
